import { render, staticRenderFns } from "./ElTestimonial1.vue?vue&type=template&id=0ebc9bac"
import script from "./ElTestimonial1.vue?vue&type=script&lang=js"
export * from "./ElTestimonial1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports